var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"usage-quota"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }